/** @format */
import React from 'react'
import styled from 'styled-components'
import { _$, Select, Option } from '@king-design/react'
import QuickRangeDate, { EDIT_GRAPH_CHART_QUICK_RANGE } from 'src/components/QuickRangeDate'
import MonitorDashboardChar from './MonitorDashboardChar'
import { delayToHours } from './constants'

interface EditGraphChartProps {
  className?: string
  setDateTime: (value: [number, number]) => void
  delayOption: number[]
  delay: number
  setDelay: (value: number) => void
  height: string
  chartData: any
}

const EditGraphChart: React.FC<EditGraphChartProps> = ({
  className,
  setDateTime,
  delayOption,
  delay,
  setDelay,
  chartData,
  height
}) => {
  return (
    <div className={className}>
      <div className="date-select">
        <QuickRangeDate
          realoadIcon={false}
          format="YYYY-MM-DD HH:mm"
          optionalDateRange={90}
          dateDiff={31}
          // defautlValue={[dayjs(1743408420000), dayjs(1743410220000)]}
          // eslint-disable-next-line no-restricted-syntax -- QuickRangeDate 与组件约定的默认范围
          defautlValue={'近0.5小时'}
          quickRange={EDIT_GRAPH_CHART_QUICK_RANGE}
          changeValue={date => {
            setDateTime(date)
          }}
        />
        <div className="delay-select">
          <Select
            slotPrefix={`${_$('周期')}：`}
            value={delay}
            onChangeValue={value => {
              setDelay(value)
            }}
            width={150}
          >
            {delayOption.length
              ? delayOption.map(item => (
                  <Option key={item} value={item}>
                    {delayToHours(item)}
                  </Option>
                ))
              : null}
          </Select>
        </div>
      </div>
      <div style={{ height: `calc(${height} - 48px)`, marginTop: 16 }}>
        <MonitorDashboardChar
          chartData={chartData}
          interval={delay}
          height={parseFloat(height) - 48}
        />
      </div>
    </div>
  )
}

export default styled(EditGraphChart)`
  .date-select {
    display: flex;
    align-items: center;
    .delay-select {
      margin-left: 16px;
    }
  }
`
